import {
  Card, Col, Row, Space, Statistic, Tag, Typography,
} from 'antd';
import { ReactElement } from 'react';
import styles from '../src/dashboard.module.less';

interface StatisticsCardOwnProps{
  tag:string
  tagColor?:string
  cardTitle:string
  primaryStatisticsValue:string
  primaryStatisticsQuantifier:string
  secondaryStatisticsValue?:string
  percentageStatistics?:ReactElement
}

const StatisticsCard = (props:StatisticsCardOwnProps) => {
  const {
    tag,
    tagColor,
    cardTitle,
    primaryStatisticsValue,
    secondaryStatisticsValue,
    percentageStatistics,
    primaryStatisticsQuantifier,
  } = props;

  return (
    <Col span={6}>
      <Card title={cardTitle}>
        <Space direction="vertical" className={styles['full-width']}>
          <Tag color={tagColor}>{tag}</Tag>
          <Row align={percentageStatistics ? 'bottom' : 'top'} justify="space-between">
            <Col>
              <div>
                <Statistic
                  value={primaryStatisticsValue}
                  valueStyle={{ fontSize: 22 }}
                />
                <Typography>{primaryStatisticsQuantifier}</Typography>
              </div>
            </Col>
            <Col>
              {secondaryStatisticsValue && (
                <Statistic
                  value={secondaryStatisticsValue}
                  valueStyle={{ fontSize: 22 }}
                />
              )}
              {percentageStatistics}
            </Col>
          </Row>
        </Space>
      </Card>
    </Col>
  );
};

StatisticsCard.defaultProps = {
  tagColor: '',
  secondaryStatisticsValue: null,
  percentageStatistics: null,
};

export default StatisticsCard;
